import {
  getNextOfKinModel
} from './models';

export default {
  setLoading(state, loading) {
    state.loading = loading;
  },

  setLoadingType(state, type) {
    state.loadingType = type;
  },

  setError(state, error) {
    state.loading = false;
    state.error = error;
  },

  setData(state, data) {
    state.data = {
      ...state.data,
      ...data
    }
  },

  setHolidays(state, holidays) {
    state.holidays = holidays;
  },

  setExcursion(state, excursionTotalPrice) {
    state.booking.payment.fullBalance = excursionTotalPrice;
  },

  setExcursionAdded(state, excursionAdded) {
    state.excursionAdded = excursionAdded;
  },
  
  setDisabledTabs(state, tabsDisabled) {
    state.tabsDisabled = tabsDisabled;
  },

  setEqual(state, data) {
    state.hideCustomAmountOption = data;
  },

  setBooking(state, booking) {

    booking.passengers.forEach(passenger => {
      if (!passenger.emergencyContacts.length) {
        passenger.emergencyContacts.push({
          ...getNextOfKinModel(),
        });
      }
    });

    state.booking = {
      ...state.booking,
      ...booking,
      excursions: [], // TODO: Remove when excursion work has been done
      subtotal: 0
    };
  },

  setDepartureDetails(state, departureDetails) {
    state.booking = {
      ...state.booking,
      departureDetails
    };
  },

  setPayment(state, payment) {
    state.booking = {
      ...state.booking,
      payment
    }
  },

  setPaymentFrame(state, paymentFrame) {
    state.paymentFrame = paymentFrame;
  },

  setTransId(state, transId) {
    state.transId = transId;
  },

  setPaymentAmount(state, data) {
    state.paymentAmount = data;
  },

  setPaymentSuccess(state, data) {
    state.paymentSuccess = data;
  },

  setPaymentError(state, data) {
    state.paymentError = data;
  },

  setExcursionData(state, excursionData) {
    state.booking = {
      ...state.booking,
      excursionData
    }
  },

  togglePassengerExcursion(state, {
    passenger,
    excursion
  }) {

    let theExcursion = state.booking.excursions.find(e => e.excursionId === excursion.activitiesId);
    if (!theExcursion) {
      theExcursion = {
        excursionId: excursion.activitiesId,
        passengers: [],
        price: excursion.price
      };
      state.booking.excursions.push(theExcursion);
    }

    let thePassenger = theExcursion.passengers.find(p => p.passengerId === String(passenger.passengerId));
    if (!thePassenger) {
      thePassenger = {
        passengerId: String(passenger.passengerId),
        selected: true
      };
      theExcursion.passengers.push(thePassenger);
    } else {
      thePassenger.selected = !thePassenger.selected;
    }

    state.booking.subtotal = 0;
    
    state.booking.subtotal = state.booking.excursions.reduce((total, excursion) => {
      return total + excursion.passengers.reduce((passengerTotal, passenger) => {
        return passengerTotal + (passenger.selected ? excursion.price : 0);
      }, 0);
    }, 0);
  },

  setUserDetails(state, data) {
    state.userDetails = data;
  },

  setActivePassengerSection(state, data) {
    state.booking.passengers[data.index].activeSection = data.title;
  },

  addNextOfKin(state, passengerIndex) {
    state.booking.passengers[passengerIndex].emergencyContacts.push(getNextOfKinModel());
  },

  removeNextOfKin(state, data) {
    state.booking.passengers[data.passengerIndex].emergencyContacts.splice(data.index, 1);
  },

  setErrorMessage(state, message) {
    state.errorMessage = message;
  },

  setTakeFinalBalanceValue(state, value) {
    state.booking.takeFinalBalance = value;
  }
}